export const COMPENDIUM_PATHS = {
  ENTRY: "entry",
  SEARCH: "search",
  BASE: "compendium",
};
